import TextToImageSpinner from './TextToImageSpinner'
import './LoadingImage.css'

const LoadingImage = ({ index, total }) => {
  return (
    <div className="LoadingImage-container">
      <div
        className={`LoadingImage ${
          index + 1 === total ? 'lastLoadingImage' : ''
        }`}
        tabIndex={0}
      >
        <TextToImageSpinner />
      </div>
    </div>
  )
}

export default LoadingImage
